import script from "./Pricing.vue?vue&type=script&setup=true&lang=js"
export * from "./Pricing.vue?vue&type=script&setup=true&lang=js"

import "./Pricing.vue?vue&type=style&index=0&id=b91108da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b91108da"]])

export default __exports__